import moment from "moment";
import { useEffect } from "react";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";

const MachineShiftAssociationModal = ({
    machine_id,
    currentSlot,
    currentShift,
    handleUpdateShifts,
}) => {
    const {
        handleSubmit,
        reset,
        register,
        formState: { errors },
        watch,
        setValue,
        control,
    } = useForm({
        defaultValues: {
            morning_shift: false,
            evening_shift: false,
            idle: false,
        },
    });

    const morning_shift = watch("morning_shift");
    const evening_shift = watch("evening_shift");
    const idle = watch("idle");
    const dateRange = watch("dateRange");

    console.log(dateRange);

    const onSubmit = (data) => {
        console.log(data);
        if (data?.evening_shift && data?.morning_shift) {
            handleUpdateShifts("both", data?.dateRange, data?.comments);
        } else if (data?.evening_shift) {
            handleUpdateShifts("night", data?.dateRange, data?.comments);
        } else if (data?.morning_shift) {
            handleUpdateShifts("morning", data?.dateRange, data?.comments);
        } else if (data?.idle) {
            handleUpdateShifts("idle", data?.dateRange, data?.comments);
        }
    };

    useEffect(() => {
        if (idle) {
            setValue("morning_shift", false);
            setValue("evening_shift", false);
        }
    }, [idle, setValue]);

    useEffect(() => {
        if (morning_shift || evening_shift) {
            setValue("idle", false);
        }
    }, [morning_shift, evening_shift, setValue]);

    useEffect(() => {
        console.log(currentShift);
        if (currentShift && currentSlot) {
            if (currentShift?.type === "both") {
                reset({
                    morning_shift: true,
                    evening_shift: true,
                    idle: false,
                    dateRange: [new Date(currentSlot), undefined],
                    comments: currentShift?.comments || "",
                });
            } else if (currentShift?.type === "morning") {
                reset({
                    morning_shift: true,
                    evening_shift: false,
                    idle: false,
                    dateRange: [new Date(currentSlot), undefined],
                    comments: currentShift?.comments || "",
                });
            } else if (currentShift?.type === "night") {
                reset({
                    morning_shift: false,
                    evening_shift: true,
                    idle: false,
                    dateRange: [new Date(currentSlot), undefined],
                    comments: currentShift?.comments || "",
                });
            } else if (currentShift?.type === "idle") {
                reset({
                    morning_shift: false,
                    evening_shift: false,
                    idle: true,
                    dateRange: [new Date(currentSlot), undefined],
                    comments: currentShift?.comments || "",
                });
            } else {
                reset({
                    morning_shift: false,
                    evening_shift: false,
                    idle: false,
                    dateRange: [new Date(currentSlot), undefined],
                    comments: currentShift?.comments || "",
                });
            }
        } else {
            reset({
                morning_shift: false,
                evening_shift: false,
                idle: false,
                dateRange: [new Date(currentSlot), undefined],
                comments: currentShift?.comments || "",
            });
        }
    }, [currentShift, currentSlot]);

    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);

    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id={`machine-shift-association-modal-${machine_id}`}
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <button className="close" data-bs-dismiss="modal">
                        <em
                            className="icon ni ni-cross"
                            aria-hidden="true"
                        ></em>
                    </button>
                    <div className="modal-header">
                        <h5 className="modal-title">Association</h5>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <span className="preview-title-lg overline-title">
                                {moment(currentSlot).format("YYYY-MM-DD")}
                            </span>
                            <div className="row">
                                <div className="col-md-12 my-2">
                                    <Controller
                                        control={control}
                                        name="dateRange"
                                        render={({
                                            field: { onChange, value },
                                        }) => (
                                            <DatePicker
                                                selectsRange
                                                startDate={value?.[0]}
                                                endDate={value?.[1]}
                                                onChange={(update) => {
                                                    onChange(update);
                                                }}
                                                minDate={moment(currentSlot)
                                                    .startOf("month")
                                                    .toDate()}
                                                maxDate={moment(currentSlot)
                                                    .endOf("month")
                                                    .toDate()}
                                                placeholderText="Select date range"
                                                className="border rounded p-2"
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label
                                        className="form-label"
                                        htmlFor="morning_shift"
                                    >
                                        Morning Shift
                                    </label>
                                    <div className="form-control-wrap">
                                        <input
                                            type="checkbox"
                                            id={`morning_shift`}
                                            {...register(`morning_shift`)}
                                        />
                                        {errors.morning_shift && (
                                            <small className="text-danger mt-1">
                                                {errors.morning_shift?.message}
                                            </small>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label
                                        className="form-label"
                                        htmlFor="evening_shift"
                                    >
                                        Evening Shift
                                    </label>
                                    <div className="form-control-wrap">
                                        <input
                                            type="checkbox"
                                            id={`evening_shift`}
                                            {...register(`evening_shift`)}
                                        />
                                        {errors.evening_shift && (
                                            <small className="text-danger mt-1">
                                                {errors.evening_shift?.message}
                                            </small>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label
                                        className="form-label"
                                        htmlFor="idle"
                                    >
                                        Idle
                                    </label>
                                    <div className="form-control-wrap">
                                        <input
                                            type="checkbox"
                                            id={`idle`}
                                            {...register(`idle`)}
                                        />
                                        {errors.idle && (
                                            <small className="text-danger mt-1">
                                                {errors.idle?.message}
                                            </small>
                                        )}
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <label className="form-label">
                                        Comments
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Comments"
                                        id="text-forms-comments"
                                        {...register("comments", {
                                            required: false,
                                        })}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-bs-dismiss="modal"
                                // disabled={isPending}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                // disabled={isPending}
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default MachineShiftAssociationModal;
